import { GroupOutlinedIcon, NoRowsOverlay } from '@shared/components';

export default function ProctoringEKycListNoRowsOverlay() {
  return <NoRowsOverlay icon={GroupOutlinedIcon} title='ยังไม่มีการยืนยันตัวตนที่รอการตรวจสอบ' />;
}
